// extracted by mini-css-extract-plugin
export default {"registration":"Registration_registration__VHV5b","title":"Registration_title__grl0Q","row":"Registration_row__WipwM"};